

//   特定URLパラメータからページ表示した場合
CF.ready(function() {
	var $myForm = document.querySelector('form[data-cf-form]');

	const urlParams = new URLSearchParams(window.location.search);
	const registerStore = urlParams.get('register_store');

	// registerStoreがある場合、フォームに値をセット
	console.log(registerStore);
	console.log($myForm.cfForm);
	if (registerStore && registerStore.length > 0 ) {
		$myForm.cfForm.setFieldValue('regstorename', registerStore);
	}
});